/**
 * @fileoverview GET handler for the "/engagement/product_recommendations(/:recommender_id)" endpoint
 */
import type { RecommendationPayload } from "@predictions/types";

import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementProductRecommendationsRecommenderId } from "./constants";

export const getEngagementProductRecommendationsRecommenderId = reactQueryFetcherAdapter(
  engagementProductRecommendationsRecommenderId,
  (signal: AbortSignal, recommenderId: string): Promise<RecommendationPayload> => {
    return fetch(`/engagement/product_recommendations/${recommenderId}`, "GET", {}, { signal });
  }
);
